import { Indexes } from "../types";

export function generateIndexesObject(data: any): Indexes {
  let indexes: Indexes = {};
  for (let i = 0; i < data.length; i++) {
    indexes[data[i].id] = i;
  }
  return indexes;
}
